import { PartiallyHighlightedText } from '@/scopes/search/components/PartiallyHighlightedText'
import { useLiveSearchStore } from '@/scopes/search/search/infrastructure/live-search/store'
import { space, tok } from '@sunwebgroup/ui-components'
import { Typography } from '@sunwebgroup/ui-components/uds'
import { styled } from 'styled-components'

const Breadcrumbs = styled(Typography)`
  margin-left: 0;
  margin-right: ${space('primitives_space_8')};
  color: ${tok('semantics_content_secondary_color')};

  &:not(:last-child) {
    &::after {
      content: ',';
    }
  }
`

const Wrapper = styled.button`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: baseline;
  padding: ${space('primitives_space_12')} ${space('primitives_space_16')};
  text-decoration: none;

  border-radius: 0;
  min-height: initial;

  width: 100%;

  &:hover {
    background-color: ${tok('primitives_color_neutral_100')};
    color: ${tok('primitives_color_primary_500')};
  }

  ${Typography} {
    ${Typography.modVariant('body-m-bold-snug')}
  }

  ${Breadcrumbs} {
    ${Typography.modVariant('body-xs-bold-snug')}
  }
`

export function Item({ name, url, breadcrumbs }: { name: string, url?: string, breadcrumbs: string[] }) {
  return (
    <Wrapper as="a" href={url}>
      <ItemText text={name} />
      {breadcrumbs.map((breadcrumb, index) => (
        <Breadcrumbs key={index}>{breadcrumb}</Breadcrumbs>
      ))}
    </Wrapper>
  )
}

function ItemText({ text }: { text: string }) {
  const { query } = useLiveSearchStore()
  return <PartiallyHighlightedText text={text} query={query} />
}
